/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_SubtitleInputs */

const en_wc_vs_subtitle = /** @type {(inputs: Wc_Vs_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both open and save .docx and share the same ribbon layout. The differences are price, openness and platforms, and how mature each one is.`)
};

/**
* | output |
* | --- |
* | "Both open and save .docx and share the same ribbon layout. The differences are price, openness and platforms, and how mature each one is." |
*
* @param {Wc_Vs_SubtitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_subtitle = /** @type {((inputs?: Wc_Vs_SubtitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_SubtitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_subtitle(inputs)
});
export { wc_vs_subtitle as "wc.vs.subtitle" }